/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './accounting-bank-account.reducer';

export const AccountingBankAccount = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const accountingBankAccountList = useAppSelector(state => state.accountingBankAccount.entities);
  const loading = useAppSelector(state => state.accountingBankAccount.loading);
  const totalItems = useAppSelector(state => state.accountingBankAccount.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="accounting-bank-account-heading" data-cy="AccountingBankAccountHeading">
        <Translate contentKey="tinyMedicRestApp.accountingBankAccount.home.title">Accounting Bank Accounts</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.accountingBankAccount.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/accounting-bank-account/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.accountingBankAccount.home.createLabel">Create new Accounting Bank Account</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.accountingBankAccount.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {accountingBankAccountList && accountingBankAccountList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('accountHolderName')}>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.accountHolderName">Account Holder Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('accountHolderName')} />
                </th>
                <th className="hand" onClick={sort('accountNo')}>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.accountNo">Account No</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('accountNo')} />
                </th>
                <th className="hand" onClick={sort('ifscCode')}>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.ifscCode">Ifsc Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('ifscCode')} />
                </th>
                <th className="hand" onClick={sort('allowedCredit')}>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.allowedCredit">Allowed Credit</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('allowedCredit')} />
                </th>
                <th className="hand" onClick={sort('maxCreditLimit')}>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.maxCreditLimit">Max Credit Limit</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('maxCreditLimit')} />
                </th>
                <th className="hand" onClick={sort('standardCreditLimit')}>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.standardCreditLimit">Standard Credit Limit</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('standardCreditLimit')} />
                </th>
                <th className="hand" onClick={sort('inactive')}>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.inactive">Inactive</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('inactive')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('entityId')}>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.entityId">Entity Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('entityId')} />
                </th>
                <th className="hand" onClick={sort('openingBalance')}>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.openingBalance">Opening Balance</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('openingBalance')} />
                </th>
                <th className="hand" onClick={sort('overDraft')}>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.overDraft">Over Draft</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('overDraft')} />
                </th>
                <th className="hand" onClick={sort('closingBalance')}>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.closingBalance">Closing Balance</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('closingBalance')} />
                </th>
                <th className="hand" onClick={sort('createdById')}>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.createdById">Created By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('createdById')} />
                </th>
                <th className="hand" onClick={sort('createdByType')}>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.createdByType">Created By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('createdByType')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.institution">Institution</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.baseCurrency">Base Currency</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.accountType">Account Type</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.accountingBankAccount.entityType">Entity Type</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {accountingBankAccountList.map((accountingBankAccount, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/accounting-bank-account/${accountingBankAccount.id}`} color="link" size="sm">
                      {accountingBankAccount.id}
                    </Button>
                  </td>
                  <td>{accountingBankAccount.accountHolderName}</td>
                  <td>{accountingBankAccount.accountNo}</td>
                  <td>{accountingBankAccount.ifscCode}</td>
                  <td>{accountingBankAccount.allowedCredit}</td>
                  <td>{accountingBankAccount.maxCreditLimit}</td>
                  <td>{accountingBankAccount.standardCreditLimit}</td>
                  <td>{accountingBankAccount.inactive ? 'true' : 'false'}</td>
                  <td>{accountingBankAccount.active ? 'true' : 'false'}</td>
                  <td>{accountingBankAccount.microSec}</td>
                  <td>{accountingBankAccount.timestampEntry}</td>
                  <td>{accountingBankAccount.lastUpdated}</td>
                  <td>{accountingBankAccount.cursor}</td>
                  <td>{accountingBankAccount.entityId}</td>
                  <td>{accountingBankAccount.openingBalance}</td>
                  <td>{accountingBankAccount.overDraft ? 'true' : 'false'}</td>
                  <td>{accountingBankAccount.closingBalance}</td>
                  <td>{accountingBankAccount.createdById}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AddedByType.${accountingBankAccount.createdByType}`} />
                  </td>
                  <td>
                    {accountingBankAccount.institution ? (
                      <Link to={`/institution/${accountingBankAccount.institution.id}`}>{accountingBankAccount.institution.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {accountingBankAccount.baseCurrency ? (
                      <Link to={`/accounting-currency/${accountingBankAccount.baseCurrency.id}`}>
                        {accountingBankAccount.baseCurrency.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {accountingBankAccount.accountType ? (
                      <Link to={`/clinical-dictionary/${accountingBankAccount.accountType.id}`}>
                        {accountingBankAccount.accountType.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {accountingBankAccount.entityType ? (
                      <Link to={`/clinical-dictionary/${accountingBankAccount.entityType.id}`}>{accountingBankAccount.entityType.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/accounting-bank-account/${accountingBankAccount.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/accounting-bank-account/${accountingBankAccount.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/accounting-bank-account/${accountingBankAccount.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.home.notFound">No Accounting Bank Accounts found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={accountingBankAccountList && accountingBankAccountList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default AccountingBankAccount;
